import { onDomReady } from '../utils/dom';

function initializeOnePageNavs() {
    if (!document.body.classList.contains('onepager')) return;

    import('purejs_onepagenav').then((module) => {
        // rolldown liefert das UMD-Paket als default-Export-Objekt ({ default: Klasse }) → beide Formen abfangen
        const OnePageNav = module.default?.default ?? module.default;
        // https://github.com/M-Zoldak/PureJS_OnePageNav/wiki/Configuration

        new OnePageNav({
            navLinksSelector: 'body.onepager .main-nav .level_1 a:not(.invisible)', // Hauptnavigation kann im Header oder im Overlay liegen
            defaultLinkActive: true,
            updateATagClass: false,
            parentsObtainingActiveClass: ['li'],
            changeOffset: 33,
        });
    });
}

onDomReady(() => {
    initializeOnePageNavs();
});
